import * as React from 'react';
import { connect } from 'react-redux';

import { UserFlags } from 'ha/constants/FeatureFlags';

import { fetchFeatureFlags } from '../actions';
import { RenderFn, FeatureStatus, FeatureFlags } from '../types';
import {
  getFeatureFlags,
  isLoadingFeatureFlags,
  isLoadedFeatureFlags,
} from '../selectors';

interface StateProps {
  features: { [F in UserFlags]: boolean };
  isLoading: boolean;
  isLoaded: boolean;
}

interface DispatchProps {
  fetchFeatures: () => void;
}

interface OwnProps {
  feature: FeatureFlags;
  children: RenderFn;
}

type Props = StateProps & DispatchProps & OwnProps;

export class UserFlag extends React.Component<Props> {
  componentDidMount() {
    if (!this.props.isLoaded && !this.props.isLoading) {
      this.props.fetchFeatures();
    }
  }

  render() {
    const { feature, features, children, isLoaded } = this.props;

    const status = !isLoaded
      ? FeatureStatus.LOADING
      : features[feature]
      ? FeatureStatus.ENABLED
      : FeatureStatus.DISABLED;

    return children(status);
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchFeatures: fetchFeatureFlags,
};

export default connect(
  (state): StateProps => ({
    features: getFeatureFlags(state),
    isLoading: isLoadingFeatureFlags(state),
    isLoaded: isLoadedFeatureFlags(state),
  }),
  mapDispatchToProps,
)(UserFlag);
